// extracted by mini-css-extract-plugin
module.exports = {"form":"resultForm_form__czR2y","input":"resultForm_input__3qcea","button":"resultForm_button__1eFg-","error":"resultForm_error__2FF6x","text":"resultForm_text__3RA2o"};